import { Api } from '@/api/api';
import { CostCentresResult } from '@/models/cost-centres-result';

export class CostCentreApi extends Api {
    public async fetchAsync(): Promise<CostCentresResult> {
        return await this.getAsync<CostCentresResult>('v2/costcentre');
    }
}
